import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findPopularityList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`creditCard/findCreditCardList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateDefaultEquity({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`creditCard/updateDefaultEquity`, { params })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  changeStatus({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`creditCard/changeStatus`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  changePopularize({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`creditCard/changePopularize`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findInfoById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`creditCard/findInfoById`, {params} )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  memberShipCardDetails({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`redeem/memberShipCardDetails`, {params} )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findAllCard({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`creditCard/findAllCard`, params )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addCreditCardList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`creditCard/addCreditCardList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  courseList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`creditCard/courseList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  child_list({ commit }, params) {
  return new Promise((resolve, reject) => {
    axios.get(`creditCard/child_list`, {params})
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
},

  top_list({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`creditCard/top_list`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getLibraryList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`creditCard/libraryList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },



}
